import React from 'react';

export default function PricingCard({ plan, featured, onSelect, isCurrent, ctaLabel }) {
  const discountPct = plan.originalPrice > plan.price
    ? Math.round(((plan.originalPrice - plan.price) / plan.originalPrice) * 100)
    : 0;
  // Plans saved before this field existed won't have it in the DB yet.
  const maxApiKeys = plan.maxApiKeys || 1;

  return (
    <div className={`pricing-card ${featured ? 'featured' : ''}`}>
      {discountPct > 0 && <div className="pricing-badge">SAVE {discountPct}%</div>}
      <div className="pricing-eyebrow">{plan.durationInDays >= 28 ? 'Monthly' : `${plan.durationInDays}-day`}</div>
      <h3>{plan.name}</h3>
      <p className="pricing-desc">{plan.description}</p>
      <div className="pricing-price">
        <span className="amount">${plan.price}</span>
        {discountPct > 0 && <span className="original">${plan.originalPrice}</span>}
        <span className="period">/ {plan.durationInDays} days</span>
      </div>
      <div className="pricing-note">{plan.monthlyCredits.toLocaleString()} credits included</div>
      <ul className="pricing-features">
        <li>{plan.monthlyCredits.toLocaleString()} API credits</li>
        <li>{plan.dailyCreditCap.toLocaleString()} credits / day cap</li>
        <li>{plan.rateLimitPerSecond} requests per second</li>
        <li>{maxApiKeys} RPC URL{maxApiKeys === 1 ? '' : 's'}</li>
        <li>{plan.allowedNetworks.length} networks included</li>
      </ul>
      <button
        className={`btn btn-block ${featured ? 'btn-primary' : 'btn-outline'}`}
        disabled={isCurrent}
        onClick={() => onSelect(plan)}
      >
        {isCurrent ? 'Current plan' : (ctaLabel || 'Choose plan')}
      </button>
    </div>
  );
}
